module.exports = __webpack_public_path__ + "img/09-ข้อมูล-membership.3bc74f0a.png";